/**
 * `dueDate` est un jour sans heure (§34). On compare donc au jour courant,
 * en neutralisant l'heure des deux côtés pour éviter les faux "en retard".
 */
export type DueDateStatus = "overdue" | "today" | "upcoming" | "none";

export const dueDateStatus = (dueDate?: string | null): DueDateStatus => {
  if (!dueDate) return "none";
  const due = new Date(dueDate);
  if (isNaN(due.getTime())) return "none";

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  due.setHours(0, 0, 0, 0);

  if (due.getTime() < today.getTime()) return "overdue";
  if (due.getTime() === today.getTime()) return "today";
  return "upcoming";
};

export const DUE_DATE_STYLES: Record<Exclude<DueDateStatus, "none">, string> = {
  overdue: "bg-red-100 text-red-700",
  today: "bg-amber-100 text-amber-700",
  upcoming: "bg-gray-100 text-gray-600 dark:bg-zinc-800 dark:text-zinc-400",
};

export const DUE_DATE_LABELS: Record<Exclude<DueDateStatus, "none">, string> = {
  overdue: "En retard",
  today: "Aujourd'hui",
  upcoming: "À venir",
};
